import { createSlice } from '@reduxjs/toolkit';
import { getSessionStorageItem } from 'libs/utils/sessionStorage';
import { AD_BLOCKER_VISITOR_KEY, IS_AD_BLOCKER_USED_SESSION_KEY } from 'constants/ads';
import { UiState } from 'constants/ui';
import { stateName } from './constants';
export const initialState = {
  placements: [],
  segmentIds: [],
  uiState: UiState.Idle,
  isAdBlockerUsed: getSessionStorageItem(IS_AD_BLOCKER_USED_SESSION_KEY) === 'true' || null,
  hasAdBlockerBeenTracked: !!getSessionStorageItem(IS_AD_BLOCKER_USED_SESSION_KEY) || false,
  adBlockerVisitorId: getSessionStorageItem(AD_BLOCKER_VISITOR_KEY) || null
};

const setAdsPlacements = (draft, action) => {
  const {
    placements
  } = action.payload;
  draft.placements = placements;
};

const setAdsSegmentIds = (draft, action) => {
  const {
    segmentIds
  } = action.payload;
  draft.segmentIds = segmentIds;
};

const setUiState = (draft, action) => {
  const {
    uiState
  } = action.payload;
  draft.uiState = uiState;
};

const setIsAdBlockerUsed = (draft, action) => {
  const {
    isAdBlockerUsed
  } = action.payload;
  if (draft.isAdBlockerUsed === isAdBlockerUsed) return;
  draft.isAdBlockerUsed = isAdBlockerUsed;
};

const setHasAdBlockerBeenTracked = (draft, action) => {
  const {
    hasAdBlockerBeenTracked
  } = action.payload;
  draft.hasAdBlockerBeenTracked = hasAdBlockerBeenTracked;
};

const setAdBlockerVisitorId = (draft, action) => {
  const {
    id
  } = action.payload;
  draft.adBlockerVisitorId = id;
};

const adsSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    setAdsPlacements,
    setAdsSegmentIds,
    setUiState,
    setIsAdBlockerUsed,
    setHasAdBlockerBeenTracked,
    setAdBlockerVisitorId
  }
});
export const {
  actions
} = adsSlice;
export const plug = {
  [stateName]: adsSlice.reducer
};
export default adsSlice.reducer;